import Vue from 'vue';
import i18n from '@/i18n';
const vue = new Vue({i18n});

export const DONE = "DONE";
export const DOING = "DOING";
export const TODO = "TODO";

export const LIST_OF_STATUS = [
    {id: 'DONE', name: vue.$t('protocol.tab-timeline.status-select.done')}, 
    {id: 'DOING', name: vue.$t('protocol.tab-timeline.status-select.doing')}, 
    {id: 'TODO', name: vue.$t('protocol.tab-timeline.status-select.todo')},
];

export const _getTimelineStatus = (status) => {
    switch (status) {
        case DONE : return vue.$t('protocol.tab-timeline.status-select.done');
        case DOING : return vue.$t('protocol.tab-timeline.status-select.doing');
        case TODO : return vue.$t('protocol.tab-timeline.status-select.todo');
    }
}
